import { Navigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { PageHeader } from "@/components/layout/PageHeader";
import { useAuth } from "@/lib/auth";
import { IntegrationsPanel } from "@/components/admin/IntegrationsPanel";
import { IssuerForm } from "@/components/admin/IssuerForm";
import { InvoiceQueue } from "@/components/admin/InvoiceQueue";

export default function Amministrazione() {
  const { user } = useAuth();
  if (user && !user.is_admin) return <Navigate to="/app" replace />;
  return (
    <div data-testid="admin-page">
      <PageHeader
        eyebrow="Amministrazione"
        title="Stato integrazioni e fatturazione"
        subtitle="Area riservata all'amministratore. I valori dei secret restano nei Production Secrets e non vengono mai mostrati."
      />
      <div className="mb-3 flex items-center gap-2">
        <h2 className="font-heading text-lg font-semibold text-slate-100">Integrazioni</h2>
        <ShieldCheck size={14} className="text-cyan-300" />
      </div>
      <IntegrationsPanel />
      <div className="mt-8 mb-3">
        <h2 className="font-heading text-lg font-semibold text-slate-100">Fatturazione elettronica</h2>
        <p className="text-xs text-slate-400 mt-1">Una fattura per ogni pagamento Stripe confermato dal webhook. Nessun invio viene effettuato senza dati emittente o credenziali Aruba.</p>
      </div>
      <div className="space-y-6">
        <IssuerForm />
        <InvoiceQueue />
      </div>
    </div>
  );
}
